<div class="total-price price-div">
  <billing-ui-simple-price-display
    [price]="oneTimeCost()"
    [frequency]="Frequency.ONE_TIME"
    [currencyCode]="currency()"
    [componentTextLength]="'verbose'"
    [allowCustomStyling]="true"
  ></billing-ui-simple-price-display>
</div>
<div class="recurring-price price-div" *ngIf="monthlyCost()">
  <billing-ui-simple-price-display
    [price]="monthlyCost()"
    [frequency]="Frequency.MONTHLY"
    [currencyCode]="currency()"
    [componentTextLength]="'verbose'"
    [allowCustomStyling]="true"
  ></billing-ui-simple-price-display>
</div>
<div class="recurring-price price-div" *ngIf="yearlyCost()">
  <billing-ui-simple-price-display
    [price]="yearlyCost()"
    [frequency]="Frequency.YEARLY"
    [currencyCode]="currency()"
    [componentTextLength]="'verbose'"
    [allowCustomStyling]="true"
  ></billing-ui-simple-price-display>
</div>
